import type { QueryClient } from "@tanstack/react-query"
import type { HqUser } from "./auth"
import { sdk } from "./medusa"

/**
 * Saves a few keys on the signed-in person's Medusa account (language, bar, starred sections), ONE
 * SAVE AT A TIME. Medusa replaces the whole metadata object, so two saves started together from the
 * same copy undid each other's key: giving a person a role saved their bar and their stars at the same
 * moment, and each page load then saved them again, back and forth. Each save here waits for the one
 * before it and starts from the account as that one left it.
 */
let chain: Promise<unknown> = Promise.resolve()

export function saveMyMetadata(queryClient: QueryClient, user: HqUser, patch: Record<string, unknown>): Promise<HqUser> {
  const run = chain.then(async () => {
    const latest = (queryClient.getQueryData(["me"]) as HqUser | undefined) ?? user
    const { user: updated } = await sdk.admin.user.update(latest.id, { metadata: { ...(latest.metadata ?? {}), ...patch } })
    queryClient.setQueryData(["me"], updated as HqUser)
    return updated as HqUser
  })
  chain = run.catch(() => undefined)
  return run
}
